<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Declaring — Surat Perintah Kerja</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3"><v-text-field v-model="form.no_spk" label="Nomor SPK *" dense /></v-col>
          <v-col cols="12" md="3"><v-text-field v-model="form.nama_customer" label="Nama Customer *" dense /></v-col>
          <v-col cols="12" md="3"><v-text-field v-model="form.penanggung_jawab" label="Penanggung Jawab *" dense /></v-col>
          <v-col cols="12" md="3"><v-text-field v-model="nilaiTagihanDisplay" inputmode="numeric" label="Nilai Tagihan *" dense /></v-col>
          <v-col cols="12" md="4"><v-text-field v-model="form.pekerjaan" label="Deskripsi Pekerjaan *" dense /></v-col>
          <v-col cols="12" md="2"><v-text-field v-model="form.tanggal_mulai" type="date" label="Tanggal Mulai *" dense /></v-col>
          <v-col cols="12" md="2"><v-text-field v-model="form.tanggal_dikerjakan" type="date" label="Tanggal Dikerjakan" dense /></v-col>
          <v-col cols="12" md="2"><v-select v-model="form.status" :items="statusOptions" label="Status" dense /></v-col>
          <v-col cols="12" md="2" v-if="form.status === 'selesai'"><v-text-field v-model="form.tanggal_selesai" type="date" label="Tanggal Selesai *" dense /></v-col>
          <v-col cols="12" :md="form.status === 'selesai' ? 10 : 12"><v-textarea v-model="form.deskripsi" label="Catatan / Deskripsi" rows="2" dense /></v-col>
        </v-row>

        <div class="d-flex align-center mb-2">
          <h3>Realisasi Pekerjaan</h3>
          <v-spacer />
          <v-btn small color="secondary" @click="addDetail"><v-icon left small>mdi-plus</v-icon>Tambah Detail</v-btn>
        </div>
        <v-row v-for="(detail, index) in form.realisasi" :key="index">
          <v-col cols="12" md="8"><v-text-field v-model="detail.keterangan" label="Keterangan" dense hide-details /></v-col>
          <v-col cols="10" md="3"><v-text-field v-model.number="detail.jumlah" type="number" label="Jumlah" dense hide-details /></v-col>
          <v-col cols="2" md="1"><v-btn icon color="error" @click="form.realisasi.splice(index, 1)"><v-icon>mdi-delete</v-icon></v-btn></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4"><v-alert dense text type="info">Total realisasi: Rp {{ money(totalRealisasi) }}</v-alert></v-col>
          <v-col cols="12" md="4"><v-alert dense text :type="labaForm >= 0 ? 'success' : 'error'">Laba bersih: Rp {{ money(labaForm) }}</v-alert></v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn text @click="reset">Batal</v-btn>
            <v-btn color="primary" :loading="loading.save" @click="save">{{ form.id ? "Update" : "Simpan SPK" }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title>
        Daftar SPK
        <v-spacer />
        <v-text-field v-model="filter.no_spk" label="Cari No. SPK" dense hide-details clearable class="mr-2" style="max-width:180px" @keyup.enter="fetchData" />
        <v-select v-model="filter.status" :items="[{text:'Semua',value:''}, ...statusOptions]" label="Status" dense hide-details style="max-width:160px" @change="fetchData" />
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :loading="loading.fetch" dense>
        <template v-slot:item.nilai_tagihan="{item}">Rp {{ money(item.nilai_tagihan) }}</template>
        <template v-slot:item.total_realisasi="{item}">Rp {{ money(item.total_realisasi) }}</template>
        <template v-slot:item.laba_bersih="{item}">Rp {{ money(item.laba_bersih) }}</template>
        <template v-slot:item.status_pelunasan="{item}">
          <v-chip small :color="item.status_pelunasan === 'lunas' ? 'success' : 'warning'">{{ item.status_pelunasan }}</v-chip>
        </template>
        <template v-slot:item.actions="{item}">
          <v-icon v-if="item.status_pelunasan !== 'lunas'" small class="mr-2" @click="edit(item)">mdi-pencil</v-icon>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" color="grey" v-bind="attrs" v-on="on">mdi-lock</v-icon>
            </template>
            <span>Batalkan pelunasan terlebih dahulu untuk mengedit</span>
          </v-tooltip>
          <v-icon v-if="item.status_pelunasan !== 'lunas'" small color="error" @click="remove(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import axios from "axios";

const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
const emptyForm = () => ({
  id: null, no_spk: "", nama_customer: "", penanggung_jawab: "", pekerjaan: "",
  nilai_tagihan: 0, tanggal_mulai: today(),
  tanggal_dikerjakan: "", tanggal_selesai: "", deskripsi: "", status: "proses", realisasi: []
});

export default {
  name: "Declaring",
  data: () => ({
    form: emptyForm(),
    items: [],
    filter: { no_spk: "", status: "" },
    loading: { save: false, fetch: false },
    statusOptions: [{ text: "Proses", value: "proses" }, { text: "Selesai", value: "selesai" }],
    headers: [
      { text: "No. SPK", value: "no_spk" }, { text: "Customer", value: "nama_customer" },
      { text: "Pekerjaan", value: "pekerjaan" }, { text: "Tagihan", value: "nilai_tagihan" },
      { text: "Total Realisasi", value: "total_realisasi" }, { text: "Laba Bersih", value: "laba_bersih" },
      { text: "Tanggal Selesai", value: "tanggal_selesai" }, { text: "Pelunasan", value: "status_pelunasan" },
      { text: "Aksi", value: "actions", sortable: false }
    ]
  }),
  computed: {
    nilaiTagihanDisplay: {
      get() { return this.money(this.form.nilai_tagihan); },
      set(value) {
        const digits = String(value || "").replace(/\D/g, "");
        this.form.nilai_tagihan = digits ? Number(digits) : 0;
      }
    },
    totalRealisasi() { return this.form.realisasi.reduce((sum, d) => sum + Number(d.jumlah || 0), 0); },
    labaForm() { return Number(this.form.nilai_tagihan || 0) - this.totalRealisasi; }
  },
  created() { this.fetchData(); },
  methods: {
    money(value) { return Number(value || 0).toLocaleString("id-ID"); },
    addDetail() { this.form.realisasi.push({ keterangan: "", jumlah: 0 }); },
    async fetchData() {
      this.loading.fetch = true;
      try { this.items = (await axios.get("declaring", { params: this.filter })).data; }
      catch (e) { alert(e.response?.data?.message || "Gagal memuat SPK"); }
      finally { this.loading.fetch = false; }
    },
    async save() {
      this.loading.save = true;
      try {
        if (this.form.id) await axios.put(`declaring/${this.form.id}`, this.form);
        else await axios.post("declaring", this.form);
        this.reset(); this.fetchData();
      } catch (e) { alert(e.response?.data?.message || "Gagal menyimpan SPK"); }
      finally { this.loading.save = false; }
    },
    edit(item) {
      if (item.status_pelunasan === "lunas") {
        alert("SPK yang sudah lunas tidak dapat diedit. Batalkan pelunasan terlebih dahulu.");
        return;
      }
      this.form = { ...item, realisasi: (item.realisasi || []).map(d => ({ keterangan: d.keterangan, jumlah: d.jumlah })) };
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    reset() { this.form = emptyForm(); },
    async remove(item) {
      if (!confirm(`Hapus SPK ${item.no_spk}?`)) return;
      try { await axios.delete(`declaring/${item.id}`); this.fetchData(); }
      catch (e) { alert(e.response?.data?.message || "Gagal menghapus SPK"); }
    }
  }
};
</script>
